import React from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
var activeDot = React.createElement(S.ActiveDot, null, React.createElement(S.Dot, {
  done: true
}));
var doneDot = React.createElement(S.Dot, {
  done: true
});
var inactiveDot = React.createElement(S.Dot, null);

var generateDot = function generateDot(stepIndex, currentActiveStep) {
  if (stepIndex < currentActiveStep) {
    return doneDot;
  }

  if (stepIndex === currentActiveStep) {
    return activeDot;
  }

  if (stepIndex > currentActiveStep) {
    return inactiveDot;
  }
};

var generateProgressBar = function generateProgressBar(index, currentActive, numberOfSteps) {
  if (index !== numberOfSteps - 1) {
    return React.createElement(S.ProgressBar, {
      done: currentActive > index
    });
  }
};

var generateSteps = function generateSteps(steps, currentActive, intl) {
  return steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) {
    return React.createElement(S.Step, {
      key: step.index
    }, generateDot(index, currentActive), generateProgressBar(index, currentActive, steps.length));
  });
};
/**
 * Progress bar showing current step of checkout process.
 */


var StatusProgressBar = function StatusProgressBar(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep;
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, generateSteps(steps, activeStep, intl));
};

export { StatusProgressBar };